import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import FormEditPicCorporate from './EditPic';
import axios from '../../../lib/axios'
import errorHandler from "../../../helpers/errorHandler";

const DataPicCorporate = () => {

    const [user, setUser] = useState([])
    const [editPic, setEditPic] = useState(false)

    const handleFetch = async () => {
        try {
            const options = {
                url: `/users/users`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                }
            }
            const { data } = await axios(options)
            setUser(data.data)
        } catch (err) {
            errorHandler({ err: err?.response?.data || err })
        }
    }

    useEffect(() => {
        handleFetch()
    }, [])

    const handleAfterSubmit = () => {
        setEditPic(false)
        handleFetch()
    }

    return (
        <>
            <div className="card"
                style={{ backgroundColor: '#F2F2F2', borderRadius: '20px' }}
            >
                <div className="card-body d-flex justify-content-between">
                    <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#3F4254', marginTop: '10px' }} className="card-title">Data PIC</h3>

                    <button class="btn btn-primary" onClick={() => setEditPic(true)}>Edit</button>
                </div>
                <hr></hr>
                <div className="card-body">
                    <div className='row'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Nama PIC
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {user.firstName} {user.lastName}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                No Telepon/HP PIC
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {user.mobilePhone}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Email PIC
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {user.email}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={editPic}
                size='lg'
                onHide={() => setEditPic(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <Modal.Title>
                        <h3 className='mb-3'>Edit Data PIC</h3>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <FormEditPicCorporate
                        close={() => handleAfterSubmit()}
                        user={user}
                    />
                </Modal.Body>
            </Modal>

        </>
    )
}

export default DataPicCorporate
